@if (currentPlatform$ | async; as platform) {
  @if (selectLikedList$ | async; as likedList) {
    <ion-header>
      <div class="header">
        <img
          src="/assets/images/icons-svg/arrow-right.svg"
          class="header__back"
          (click)="goBack()"
        />
        <app-text
          [text]="galleryData.chosenImgIndex | photoViewCounter: imagesList.length"
          [textType]="TextType.base"
          [textSize]="TextSizes.h1Header"
        ></app-text>
        @if (favouritesListToBeUpdated$ | async; as favouritesListToBeUpdated) {
          <svg
            icon="fav-photo-icon"
            class="fav-icon fav-icon_small"
            (click)="onFavoriteButtonClick(favouritesListToBeUpdated)"
            [ngClass]="{
              'fav-icon_active': !isFileNotFav(favouritesListToBeUpdated),
              'fav-icon_disable': (isLoadingFavorite$ | async) === true,
            }"
          ></svg>
        }
      </div>
    </ion-header>
    <div
      #columnsView
      class="gallery__columns"
      (scroll)="platform !== CurrentPlatform.desktop && onScroll($event)"
    >
      <div class="gallery__slider">
        @if (platform !== CurrentPlatform.desktop) {
          <ng-container *ngTemplateOutlet="userDataBlock"></ng-container>
        }
        <div class="image-gallery__container">
          <div class="image-gallery__swiper">
            @if (platform === CurrentPlatform.desktop && imagesList.length > 1) {
              <div
                class="image-gallery__arrow image-gallery__arrow_left"
                [class.image-gallery__arrow_disabled]="
                  galleryData.isLoopDisabled && swiper?.swiperRef?.realIndex === 0
                "
              >
                <app-image
                  [img]="'assets/images/icons-svg/arrow-right-big.svg'"
                  [rotateAngle]="180"
                  (click)="swiper?.swiperRef?.slidePrev()"
                ></app-image>
              </div>
            }
            @if (!!config) {
              <swiper
                #swiper
                class="swiper"
                [class.swiper_fullscreen]="galleryData.hideInputs"
                [config]="config"
                [keyboard]="platform === CurrentPlatform.desktop"
                [autoHeight]="platform !== CurrentPlatform.desktop"
                [slidesPerView]="1"
                [slidesPerView]="1"
                [longSwipesRatio]="0.05"
                (slideChange)="slideChanged()"
              >
                @for (img of imagesList; track img) {
                  <ng-template swiperSlide>
                    <div class="swiper__item">
                      <img
                        [src]="img | getImagePreview: ImagePreviewType.fullScreen"
                        (click)="openFullscreenModal()"
                      />
                      @if (favouritesListToBeUpdated$ | async; as favouritesListToBeUpdated) {
                        @if (platform === CurrentPlatform.desktop) {
                          <svg
                            icon="fav-photo-icon"
                            class="fav-icon"
                            (click)="onFavoriteButtonClick(favouritesListToBeUpdated)"
                            [ngClass]="{
                              'fav-icon_active': !isFileNotFav(favouritesListToBeUpdated),
                              'fav-icon_disable': (isLoadingFavorite$ | async) === true,
                            }"
                          ></svg>
                        }
                      }
                    </div>
                  </ng-template>
                }
              </swiper>
            }
            @if (platform === CurrentPlatform.desktop && imagesList.length > 1) {
              <div
                class="image-gallery__arrow image-gallery__arrow_right"
                [class.image-gallery__arrow_disabled]="
                  galleryData.isLoopDisabled &&
                  swiper?.swiperRef?.realIndex === imagesList.length - 1
                "
              >
                <app-image
                  [img]="'assets/images/icons-svg/arrow-right-big.svg'"
                  (click)="swiper?.swiperRef?.slideNext()"
                ></app-image>
              </div>
            }
          </div>
          <div class="image-gallery__counter">
            @if (!!galleryData.photoReportData) {
              <b>{{ galleryData.photoReportData.name }} ({{ galleryData.photoReportData.city }})</b>
              <b>{{ galleryData.photoReportData.category }}</b>
            }
            <span>{{ galleryData.chosenImgIndex + 1 }}/{{ imagesList.length }}</span>
          </div>
        </div>
      </div>
      <div class="gallery__comments">
        <div
          #commentsView
          class="comments"
          (scroll)="platform === CurrentPlatform.desktop && onScroll($event)"
        >
          <div class="comments__user">
            @if (platform === CurrentPlatform.desktop) {
              <ng-container *ngTemplateOutlet="userDataBlock"></ng-container>
            }
            @if (!galleryData.hideInputs && imagesList && imagesList[galleryData.chosenImgIndex]) {
              <app-post-information
                [postId]="imagesList[galleryData.chosenImgIndex].id"
                [postCommentsCount]="commentsCount"
                [postIsLiked]="likedList | isImageLiked: imagesList[galleryData.chosenImgIndex]"
                [postLikesCount]="
                  likedList | getImagesLikesCount: imagesList[galleryData.chosenImgIndex]
                "
                [viewType]="ViewTypesList.gallery"
                [hideComments]="true"
              ></app-post-information>
            }
          </div>
          @if (platform !== CurrentPlatform.desktop && imagesList[galleryData.chosenImgIndex]) {
            <ion-popover
              [isOpen]="openImageId"
              [trigger]="imagesList[galleryData.chosenImgIndex].id"
              (didDismiss)="openImageId = undefined"
              [dismissOnSelect]="true"
              side="bottom"
              alignment="start"
              [showBackdrop]="false"
            >
              <ng-template>
                <ion-content [forceOverscroll]="false">
                  <app-dropdown-menu
                    (closeModalEvent)="openImageId = undefined"
                    [fileId]="openImageId"
                    [isFavourite]="imagesList[galleryData.chosenImgIndex].favorite"
                    [dataType]="DataTypesList.image"
                    class="dropdown-menu"
                  ></app-dropdown-menu>
                </ion-content>
              </ng-template>
            </ion-popover>
          }
          @if (comments && !galleryData.hideComments) {
            <div class="comments__list" appIonScrollBar>
              @for (comment of comments; track trackByFn($index, comment)) {
                <app-post-comment
                  [id]="comment.id"
                  [comment]="comment"
                  [newComment]="newComment"
                  [editCommentId]="editCommentId"
                  [changeCommentEditMode]="changeCommentEditMode"
                ></app-post-comment>
              }
              @if (isLoading && isFirstLoading) {
                <div class="spinner">
                  <ion-spinner></ion-spinner>
                </div>
              }
            </div>
          }
        </div>
        @if (platform === CurrentPlatform.desktop) {
          <div class="gallery__comment">
            @if (!galleryData.hideInputs) {
              <app-add-comment (emitComment)="createComment($event)"></app-add-comment>
            }
          </div>
        }
      </div>
    </div>
    @if (!galleryData.hideInputs && platform !== CurrentPlatform.desktop) {
      <ion-footer>
        <div #commentContainer class="gallery__comment gallery__comment_padding">
          <app-add-comment (emitComment)="createComment($event)"></app-add-comment>
        </div>
      </ion-footer>
    }
  }
}

<ng-template #userDataBlock>
  @if (imagesList && imagesList[galleryData.chosenImgIndex]?.owner && !galleryData.userData) {
    <app-user-data
      [id]="imagesList[galleryData.chosenImgIndex].owner?.id"
      [imgSrc]="imagesList[galleryData.chosenImgIndex].owner?.avatar?.previewNormal"
      [fullName]="imagesList[galleryData.chosenImgIndex].owner | getFullName"
      [position]="imagesList[galleryData.chosenImgIndex].owner?.userPosition?.name"
    ></app-user-data>
  }

  @if (galleryData.userData) {
    <app-user-data
      [id]="galleryData.userData.id"
      [imgSrc]="galleryData.userData.avatar?.previewNormal"
      [fullName]="galleryData.userData | getFullName"
      [position]="galleryData.userData.userPosition?.name"
    ></app-user-data>
  }
</ng-template>

<div class="gallery__close" (click)="closeModal()">
  <app-svg icon="close"></app-svg>
</div>
